
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rdv/pickup",
      function () {
        return require("private-next-pages/rdv/pickup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rdv/pickup"])
      });
    }
  